import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/Card'
import React, { useState } from 'react'
import {
  User,
  Settings,
  Shield,
  Key,
  LogOut,
  X,
  CreditCard,
  Users,
  Building,
} from 'lucide-react'
import { ProfileSection } from './ProfileSection'
import { EmailChangeSection } from './EmailSection'
import PasswordSection from './PasswordSection'
import LogoutSection from './LogoutSection'
import TwoFactorSection from './TwoFactorSection'
import { useNavigate, useLocation } from 'react-router-dom'
import BillingSection from './BillingSection'
import UsersSection from './UsersSection'
import SpaceSettingsSection from './SpaceSettingsSection'

export default function AccountPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const initialSection = new URLSearchParams(location.search).get('section') ?? 'profile'
  const sections = [
    { id: 'profile', label: 'Profile', icon: User },
    { id: 'email', label: 'Email', icon: Settings },
    { id: 'security', label: 'Security', icon: Shield },
    { id: 'password', label: 'Password', icon: Key },
    { id: 'billing', label: 'Billing', icon: CreditCard },
    { id: 'users', label: 'Users', icon: Users },
    { id: 'space-settings', label: 'Space Settings', icon: Building },
    { id: 'logout', label: 'Logout', icon: LogOut },
  ]

  const [activeSection, setActiveSection] = useState<string>(initialSection)
  return (
    <div className="mx-auto min-h-screen max-w-4xl pt-4">
      <div className="mb-6 flex justify-between px-4">
        <div>
          <h3 className="font-bold text-txt-secondary">Account Settings</h3>
          <p className="mb-4 text-txt-secondary">
            Manage your account information and security settings
          </p>
        </div>

        <Button variant="ghost" className="" onClick={() => navigate(-1)}>
          <X className="h-6 w-6" />
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
        <div className="md:col-span-1">
          <Card className="w-auto p-4">
            <nav className="space-y-2">
              {sections.map((section) => {
                const Icon = section.icon
                return (
                  <Button
                    key={section.id}
                    variant={activeSection === section.id ? 'default' : 'ghost'}
                    className="w-full justify-start"
                    onClick={() => setActiveSection(section.id)}
                  >
                    <Icon className="mr-2 h-4 w-4" />
                    {section.label}
                  </Button>
                )
              })}
            </nav>
          </Card>
        </div>

        <div className="md:col-span-3">
          <Card className="w-auto p-6">
            {activeSection === 'profile' && <ProfileSection />}
            {activeSection === 'email' && <EmailChangeSection />}
            {activeSection === 'security' && <TwoFactorSection />}
            {activeSection === 'password' && <PasswordSection />}
            {activeSection === 'logout' && <LogoutSection />}
            {activeSection === 'billing' && <BillingSection />}
            {activeSection === 'users' && <UsersSection />}
            {activeSection === 'space-settings' && <SpaceSettingsSection />}
          </Card>
        </div>
      </div>
    </div>
  )
}
